import { BaseProgressBar, BaseProgressBarProps } from './ProgressBar';

import * as BarVariants from './BarVariants';
import * as TextVariants from './TextVariants';

interface Props extends Omit<BaseProgressBarProps, 'ProgressText' | 'ProgressBar'> {
    textVariant: 'text-aside' | 'text-inside-with-estimation';
}

const THEME_MAP: Record<Props['theme'], (typeof BarVariants)[keyof typeof BarVariants]> = {
    light: BarVariants.LinearProgressLight,
    dark: BarVariants.LinearProgressDark,
} as const;

const TEXT_VARIANT_MAP: Record<Props['textVariant'], (typeof TextVariants)[keyof typeof TextVariants]> = {
    'text-aside': TextVariants.TextProgressAside,
    'text-inside-with-estimation': TextVariants.TextProgressInsideWithEstimation,
} as const;

export const ProgressBar = ({ theme, textVariant, ...baseProps }: Props) => (
    <BaseProgressBar {...baseProps} theme={theme} ProgressBar={THEME_MAP[theme]} ProgressText={TEXT_VARIANT_MAP[textVariant]} />
);

export default {
    Component: BaseProgressBar,
    ...TextVariants,
    ...BarVariants,
};
